import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito mucho capital?',
    a: 'No, esto es para pasar pruebas de fondeo desde $10k hasta $150k.'
  }, {
    q: '¿Sirve para Micro NASDAQ (MNQ)?',
    a: 'Sí, es ideal para cuentas pequeñas para reducir el estrés emocional.'
  }, {
    q: '¿Tengo que saber mucho de trading?',
    a: 'Debes conocer lo básico (velas, soporte, resistencia), el resto lo cubrimos aquí.'
  }, {
    q: '¿Qué pasa si pierdo un trade?',
    a: "Usamos la regla de 'Dos fallos y fuera' para proteger tu capital emocional."
  }];
  return <section className="py-20 bg-trading-card/30" data-id="element-55">
      <div className="container mx-auto px-4" data-id="element-56">
        <div className="max-w-3xl mx-auto" data-id="element-57">
          <h2 className="text-3xl md:text-4xl font-heading text-center text-white mb-12" data-id="element-58">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-59">
            {faqs.map((faq, idx) => <FAQItem key={idx} question={faq.q} answer={faq.a} data-id="element-60" />)}
          </div>
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-white/10 rounded-lg bg-trading-card overflow-hidden" data-id="element-61">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-62">
        <span className="font-heading text-lg text-white" data-id="element-63">{question}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} data-id="element-64">
          <ChevronDownIcon className="w-5 h-5 text-trading-gold" data-id="element-65" />
        </motion.div>
      </button>

      <AnimatePresence data-id="element-66">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-67">
            <div className="px-6 pb-4 text-slate-400 text-sm" data-id="element-68">{answer}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}